import { createAction, createReducer, on } from '@ngrx/store';
import {
  cancelPropertyDetailsShare,
  generatePropertyDetailsShare,
  propertyDetailsShareFailed,
  propertyDetailsShareSucceeded
} from '@store/property-details-share/property-details-share.actions';
import { initialPropertyDetailsShareState } from '@store/property-details-share/property-details-share.model';
import { LOGOUT_SUCCESS } from '@store/user/user.actions';

export const propertyDetailsShareReducer = createReducer(
  initialPropertyDetailsShareState,
  on(generatePropertyDetailsShare, (_state, { requestId }) => ({
    ...initialPropertyDetailsShareState,
    requestId,
    status: 'loading' as const
  })),
  on(propertyDetailsShareSucceeded, (state, { requestId, response }) =>
    state.requestId === requestId && state.status === 'loading'
      ? { ...state, status: 'ready' as const, response, errorMessage: null }
      : state
  ),
  on(propertyDetailsShareFailed, (state, { requestId, errorMessage }) =>
    state.requestId === requestId && state.status === 'loading'
      ? { ...state, status: 'error' as const, response: null, errorMessage }
      : state
  ),
  on(cancelPropertyDetailsShare, (state, { requestId }) =>
    state.requestId === requestId && state.status !== 'idle' ? initialPropertyDetailsShareState : state
  ),
  on(createAction(LOGOUT_SUCCESS), () => initialPropertyDetailsShareState)
);
